import { httpClient } from '@src/api/core';
import { API_ENDPOINTS } from '@src/constants/apiEndpoints';
import { RouterPath } from '@src/constants/router_path';
import { deleteAllStorageValue } from '@src/modules/local_storage_utils';
import { getRefreshToken } from '@src/modules/security/authHelpers';
import { clearAuth } from '@src/store/slices/auth';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * ログアウトフック
 * ログアウト処理を提供する再利用可能なフック
 */
export function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = useCallback(async (): Promise<void> => {
    try {
      const refreshToken = getRefreshToken();

      if (refreshToken) {
        // ログアウトAPIを呼び出し
        await httpClient.post(API_ENDPOINTS.AUTH.LOGOUT.replace(/^\//, ''), {
          refreshToken,
        });
      }
    } catch (_error) {
      // Logout APIのエラーは無視（ローカル状態のクリアは必ず実行）
      console.warn('Logout API failed, but continuing with local cleanup');
    } finally {
      // 認証状態をクリア
      dispatch(clearAuth());

      // ローカルストレージを完全削除
      deleteAllStorageValue();

      // ログイン画面へリダイレクト
      navigate(RouterPath.login);
    }
  }, [dispatch, navigate]);

  return { logout };
}
